import { lazy, Suspense } from "react";

import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import { AnimatedLoader } from "@/components/Loaders/AnimatedLoader";
import { useLocaleInfo } from "@/hooks/useLocaleInfo";

const ArabicTerms = lazy(() => import("./ArabicTerms"));
const EnglishTerms = lazy(() => import("./EnglishTerms"));

export const MoreDetailsDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { locale } = useLocaleInfo();

  return (
    <SwipeableDrawer
      onClose={onClose}
      open={open}
      hasFullHeight
      heightOffset={100}
    >
      {open ? (
        <div className="prose-sm">
          <Suspense fallback={<AnimatedLoader icon="users" />}>
            {locale === "ar" ? <ArabicTerms /> : <EnglishTerms />}
          </Suspense>
        </div>
      ) : null}
    </SwipeableDrawer>
  );
};
